// extracted by mini-css-extract-plugin
export default {"root":"SearchBarPanel__root--URHdk"};